export default {
      id: "minus-usage",
      viewBox: "0 0 16 2",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#minus",
      toString: function () {
        return this.url;
      }
    }